export const environment = {
	production: false,
	backendUrl: 'https://backend.stream-qa.zerohour-productions.net:12443',
	websocketServerUrl: 'wss://backend.stream-qa.zerohour-productions.net:12443'
};
